export type KnowledgeBaseErrorKind = 'network' | 'permission' | 'notFound' | 'generic';

const getErrorStatus = (error: unknown): number | string | undefined => {
  if (!error || typeof error !== 'object') return undefined;

  const value = error as {
    status?: number | string;
    response?: { status?: number | string };
    code?: string;
  };

  return value.status ?? value.response?.status ?? value.code;
};

export const mapKnowledgeBaseError = (error: unknown): KnowledgeBaseErrorKind => {
  const status = getErrorStatus(error);

  if (status === 'FETCH_ERROR' || status === 'ERR_NETWORK') return 'network';
  if (status === 401 || status === 403) return 'permission';
  if (status === 404) return 'notFound';

  return 'generic';
};

export const getKnowledgeBaseErrorMessageKey = (
  error: unknown,
  context:
    | 'load'
    | 'upload'
    | 'delete'
    | 'availability'
    | 'retry'
    | 'search'
    | 'original'
    | 'assignments' = 'load',
): string =>
  context === 'upload'
    ? `campaignPage.knowledgeBase.errors.upload.${mapKnowledgeBaseError(error)}`
    : context === 'delete'
      ? `campaignPage.knowledgeBase.errors.delete.${mapKnowledgeBaseError(error)}`
      : context === 'availability'
        ? `campaignPage.knowledgeBase.errors.availability.${mapKnowledgeBaseError(error)}`
        : context === 'retry'
          ? `campaignPage.knowledgeBase.errors.retry.${mapKnowledgeBaseError(error)}`
          : context === 'search'
            ? `campaignPage.knowledgeBase.errors.search.${mapKnowledgeBaseError(error)}`
            : context === 'original'
              ? `campaignPage.knowledgeBase.errors.original.${mapKnowledgeBaseError(error)}`
              : context === 'assignments'
                ? `campaignPage.knowledgeBase.errors.assignments.${mapKnowledgeBaseError(error)}`
                : `campaignPage.knowledgeBase.errors.${mapKnowledgeBaseError(error)}`;

export const KNOWLEDGE_BASE_PROCESSING_ERROR_KEY =
  'campaignPage.knowledgeBase.errors.processingFailed';
